module.exports = __webpack_public_path__ + "img/xindc.06ee2599.svg";